import React from 'react';

const ProExclusiveLogo = () => {
  return (
    <div className="tw-flex tw-items-center tw-gap-12">
      <div className="tw-bg-grayscale-50 tw-h-px sm:tw-h-3 tw-w-full" />
      <p className="tw-flex-shrink-0 tw-m-0">
        <span className="tw-font-serif tw-font-medium tw-text-[15px] tw-text-pro-red">Pro</span>{' '}
        <span className="tw-font-sans tw-text-overline tw-text-grayscale-80 tw-uppercase">
          Exclusive
        </span>
      </p>
      <div className="tw-bg-grayscale-50 tw-h-px sm:tw-h-3 tw-w-full" />
    </div>
  );
};

export default ProExclusiveLogo;
